export default __webpack_public_path__ + "static/media/alagard.685ec71b.ttf";